import React,{useState,useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
//import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import {Tools} from './Tools';
import {Inc,Owner} from './Inc';
import useStyles from './Styles';
import Ajax from './Ajax';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';

interface ChangeOwnerProps {
	isOpen:boolean,
	customerId:number,
	comissions():void,
    close(): void,
	change(switchId:number,isNew:boolean):void,
}

const ChangeOwner: React.FC<ChangeOwnerProps> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	const defaultStates = {
		owners: [] as Owner[],
		forceFirst: false,
		isLoading: true,
	};
	const [states,setStates] = useState(defaultStates)

	const load = ()=>{
		//Ajax.setEditorId(props.managerId);
        Ajax.send("profile/list",{customer_id:props.customerId},(res:any)=>{
            //console.log("profile/list",res);
            if( res.ok ){
				let owners = [] as Owner[];
				for( let i=0; i<5; i++ ){
					owners.push(Inc.defaultOwner());
				}
				for( let i=0; i<res.owners.length; i++ ){
					owners[ res.owners[i].switch_id-1 ] = res.owners[i];
				}
                setStates({...states,"isLoading":false,"owners":owners,"forceFirst":res.owners.length===0})
            }
        });		
	}

	useEffect(()=>{
		if( props.isOpen ){
			load();
		} else {
			setStates(defaultStates);			
		}
	},[props.isOpen]);

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">プロフィール</DialogTitle>
			<DialogContent>
				<div className={classes.confirmGuide}>
					一つの会員登録で最大５個までのプロフィール（作家名義）を使い分けることができます
					<ul className={classes.hintUl}>
						<li className={classes.hintLi}>・支払申請ではすべてのプロフィールの売上が合算されます</li>
						<li className={classes.hintLi}>・支払申請や退会手続きはメインプロフィール<TheaterComedyIcon color="primary" style={{verticalAlign:'bottom'}}/>以外ではできません</li>
					</ul>
				</div>
				{states.isLoading ? (
				<Box style={{textAlign:'center',padding:'2em 0'}}><CircularProgress/></Box>
				):(
				<List>
				{states.owners.map((owner:Owner,index:number)=>{
					const key = 'owner'+index;
					let no = '';
					let src = '';
					let name = '空き';
					let main = (null)
					let disabled = false;
					if( owner.owner_id>0 ){
						if( owner.img_id>0 ){
							src = Tools.getStoreImg(owner.owner_id,owner.img_id);
						}
						name = owner.owner_name;
						no = "ID:"+owner.owner_id;
					} else if(states.forceFirst && index>0 ) {
						disabled = true;
					} else {
						no = '新しいプロフィールを登録できます';
					}
					if( index===0 ){
						main = <Tooltip title="メイン"><TheaterComedyIcon color="primary"/></Tooltip>
					}
					return (
						<ListItem
							key={key}
							disablePadding
							secondaryAction={main}
						>
							<ListItemButton divider onClick={()=>props.change(index+1,owner.owner_id===0)} disabled={disabled}>
								{src!=='' ? (
								<ListItemAvatar>
									<Avatar src={src}/>
								</ListItemAvatar>
								):(
								<ListItemIcon>
									{index===0 && <LooksOneIcon sx={{width:36,height:36}}/>}
									{index===1 && <LooksTwoIcon sx={{width:36,height:36}}/>}
									{index===2 && <Looks3Icon sx={{width:36,height:36}}/>}
									{index===3 && <Looks4Icon sx={{width:36,height:36}}/>}
									{index===4 && <Looks5Icon sx={{width:36,height:36}}/>}
								</ListItemIcon>
								)}
								<ListItemText primary={name} secondary={no}/>
							</ListItemButton>
						</ListItem>
					);
				})}
				</List>
				)}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" color="primary" onClick={props.close} style={{marginRight:'0.25em'}}>変更しない</Button>
			</DialogActions>
        </Dialog>
	);
}

export default ChangeOwner;
